define(['app'], function (app) {
  return app.Backbone.Model.extend({
    defaults: {
      source: false,
      source_thumb: false,
      cropped: false
    },

    getAvatar: function () {
      return this.get('source_thumb')
    },

    getFullAvatar: function () {
      return this.get('source')
    }
  })
})
